export default __webpack_public_path__ + "static/media/search-icon-active.e723fe25.svg";